import { IApiResponse, IBaseData } from '@datatype/common/api-type';

export enum EApiPlatfrom {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
}

// ###################################
// push token
// ###################################
export interface IPushTokenData extends IBaseData {
  platform: EApiPlatfrom;
  service: 'IYAGIGO';
}

export interface ICreatePushTokenRequest {
  deviceId: string;
  platform: EApiPlatfrom;
  service: 'IYAGIGO';
  token: string | null;
}
